export default
	[
		{
			path: '',
			redirect: 'shipOwnerCertificationAudit'
		},
		// ----------------货主认证审核
		// 货主审核
		{
			path: 'cargoOwnerAudit',
			name: 'consignorCenter/cargoOwnerAudit',
			component: () => import('@/page/consignorCenter/cargoOwnerAudit'),
			meta: { openKeyName: '货主认证审核', selectKeyUrl: 'cargoOwnerAudit' }
		},
		{
			path: 'cargoOwnerAudit/:id',
			name: 'consignorCenter/cargoOwnerAuditDetail',
			component: () => import('@/page/consignorCenter/cargoOwnerAuditDetail'),
			meta: { openKeyName: '货主认证审核', selectKeyUrl: 'cargoOwnerAudit' },
			props: true
		},
		// ----------------船主及船舶审核
		// 船主认证审核
		{
			path: 'shipOwnerCertificationAudit',
			name: 'shipOwnerAndShipCenter/shipOwnerCertificationAudit',
			component: () => import('@/page/shipOwnerAndShipCenter/shipOwnerCertificationAudit'),
			meta: { openKeyName: '船主及船舶审核', selectKeyUrl: 'shipOwnerCertificationAudit' }
		},
		{
			path: 'shipOwnerCertificationAudit/:id',
			name: 'shipOwnerAndShipCenter/shipOwnerCertificationAudit/detail',
			component: () => import('@/page/shipOwnerAndShipCenter/shipOwnerCertificationAuditDetail'),
			meta: { openKeyName: '船主及船舶审核', selectKeyUrl: 'shipOwnerCertificationAudit' },
			props: true
		},
		{
			path: 'shipOwnerCertificationNoAudit/:id',
			name: 'shipOwnerAndShipCenter/shipOwnerCertificationNoAudit/detail',
			component: () => import('@/page/shipOwnerAndShipCenter/shipOwnerCertificationNoAudit'),
			meta: { openKeyName: '船主及船舶审核', selectKeyUrl: 'shipOwnerCertificationAudit' },
			props: true
		},
		// 船舶认证审核
		{
			path: 'shipCertificationAudit',
			name: 'shipOwnerAndShipCenter/shipCertificationAudit',
			component: () => import('@/page/shipOwnerAndShipCenter/shipCertificationAudit'),
			meta: { openKeyName: '船主及船舶审核', selectKeyUrl: 'shipCertificationAudit' }
		},
		{
			path: 'shipCertificationAudit/:id',
			name: 'shipOwnerAndShipCenter/shipCertificationAudit/detail',
			component: () => import('@/page/shipOwnerAndShipCenter/shipCertificationAuditDetail'),
			meta: { openKeyName: '船主及船舶审核', selectKeyUrl: 'shipCertificationAudit' },
			props: true
		},

		// -----------------水运结算与财税风控
		// 开票审核
		{
			path: 'invoiceApproval', // riskControlCenter/invoiceApproval
			name: 'riskControlCenter/invoiceApproval',
			component: () => import('@/page/riskControlCenter/invoiceApproval'),
			meta: { openKeyName: '水运结算与财税风控', selectKeyUrl: 'invoiceApproval' }
		},
		// 开票审核 - 货主
		{
			path: 'invoiceRecOfCargoowner', // riskControlCenter/invoiceRecOfCargoowner
			name: 'riskControlCenter/invoiceRecOfCargoowner',
			component: () => import('@/page/riskControlCenter/invoiceRecOfCargoowner'),
			meta: { openKeyName: '水运结算与财税风控', selectKeyUrl: 'invoiceRecOfCargoowner' }
		},
		// 开票审核 - 船主
		{
			path: 'invoiceRecOfShipowner', // riskControlCenter/invoiceApprovalOfShipowner
			name: 'riskControlCenter/invoiceApprovalOfShipowner',
			component: () => import('@/page/riskControlCenter/invoiceApprovalOfShipowner'),
			meta: { openKeyName: '水运结算与财税风控', selectKeyUrl: 'invoiceRecOfShipowner' }
		},

		// 2.0.0 陆运
		// -----------------陆运认证审核
		// 平台司机审核
		{
			path: 'platformDriverAudit',
			name: 'riskControlCenter/platformDriverAudit',
			component: () => import('@/page/riskControlCenter/platformDriverAudit'),
			meta: { openKeyName: '陆运认证审核', selectKeyUrl: 'platformDriverAudit' }
		},
		{
			path: 'platformDriverAudit/:id',
			name: 'riskControlCenter/platformDriverAudit/detail',
			component: () => import('@/page/riskControlCenter/platformDriverAuditDetail'),
			meta: { openKeyName: '陆运认证审核', selectKeyUrl: 'platformDriverAudit' },
			props: true
		},

		// 车队审核
		{
			path: 'truckFleetAudit',
			name: 'riskControlCenter/truckFleetAudit',
			component: () => import('@/page/riskControlCenter/truckFleetAudit'),
			meta: { openKeyName: '陆运认证审核', selectKeyUrl: 'truckFleetAudit' }
		},
		{
			path: 'truckFleetAudit/:id',
			name: 'riskControlCenter/truckFleetAudit/detail',
			component: () => import('@/page/riskControlCenter/truckFleetAuditDetail'),
			meta: { openKeyName: '陆运认证审核', selectKeyUrl: 'truckFleetAudit' },
			props: true
		},

		// 车队司机
		{
			path: 'fleetDriverAudit',
			name: 'riskControlCenter/fleetDriverAudit',
			component: () => import('@/page/riskControlCenter/fleetDriverAudit'),
			meta: { openKeyName: '陆运认证审核', selectKeyUrl: 'fleetDriverAudit' }
		},
		{
			path: 'fleetDriverAudit/:id',
			name: 'riskControlCenter/fleetDriverAudit/detail',
			component: () => import('@/page/riskControlCenter/fleetDriverAuditDetail'),
			meta: { openKeyName: '陆运认证审核', selectKeyUrl: 'fleetDriverAudit' },
			props: true
		},

		// 车队车辆
		{
			path: 'fleetCarAudit',
			name: 'riskControlCenter/fleetCarAudit',
			component: () => import('@/page/riskControlCenter/fleetCarAudit'),
			meta: { openKeyName: '陆运认证审核', selectKeyUrl: 'fleetCarAudit' }
		},
		{
			path: 'fleetCarAudit/:id',
			name: 'riskControlCenter/fleetCarAudit/detail',
			component: () => import('@/page/riskControlCenter/fleetCarAuditDetail'),
			meta: { openKeyName: '陆运认证审核', selectKeyUrl: 'fleetCarAudit' },
			props: true
		},

		// -----------------陆运结算与财税风控
		// 开票审核
		{
			path: 'truckInvoiceApproval',
			name: 'riskControlCenter/truckInvoiceApproval',
			component: () => import('@/page/riskControlCenter/truckInvoiceApproval'),
			meta: { openKeyName: '陆运结算与财税风控', selectKeyUrl: 'truckInvoiceApproval' }
		},
		// 开票审核 - 货主
		{
			path: 'truckInvoiceRecOfCargoowner',
			name: 'riskControlCenter/truckInvoiceRecOfCargoowner',
			component: () => import('@/page/riskControlCenter/truckInvoiceRecOfCargoowner'),
			meta: { openKeyName: '陆运结算与财税风控', selectKeyUrl: 'truckInvoiceRecOfCargoowner' }
		},
		// 开票审核 - 司机
		{
			path: 'invoiceRecOfDriver',
			name: 'riskControlCenter/invoiceRecOfDriver',
			component: () => import('@/page/riskControlCenter/truckInvoiceRecOfDriver'),
			meta: { openKeyName: '陆运结算与财税风控', selectKeyUrl: 'invoiceRecOfDriver' }
		},
	]



// WEBPACK FOOTER //
// ./src/router/riskControlCenter/index.js